import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginAdmin } from '../../store/actions/adminActions';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { admin, loading, error } = useSelector(state => state.adminState);

    usePageTitle("Admin Login | Dinara Fariz");

    useEffect(() => {
        if (admin) {
            navigate('/admin');
        }
    }, [admin, navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginAdmin({ username, password }));
    };

    return (
        <div className="max-w-xl mx-auto px-4 md:px-6 py-8 md:py-16">
            <div className="max-w-md mx-auto border border-gray-200 p-6 md:p-8">
                <h1 className="text-2xl md:text-3xl font-light uppercase tracking-[0.2em] text-center mb-8">
                    Admin Login
                </h1>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label
                            htmlFor="username"
                            className="block text-xs uppercase tracking-[0.2em] text-gray-500 mb-2"
                        >
                            Username
                        </label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-black transition"
                            required
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="password"
                            className="block text-xs uppercase tracking-[0.2em] text-gray-500 mb-2"
                        >
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-black transition"
                            required
                        />
                    </div>

                    {error && (
                        <p className="text-sm text-red-600 text-center">
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full border border-black px-4 py-3 text-sm uppercase tracking-[0.2em] text-black hover:bg-black hover:text-white transition disabled:opacity-60"
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;